<template>
    <by-effect>
        <template v-slot:header>
            <!-- <img src="../../../assets/images/doctor/by-effects/cough.png" alt="effect image"> -->
            <picture>
                <source media="(max-width: 599px)" srcset="../../../assets/images/doctor/by-effects/cough-mobile.png">
                <source media="(min-width: 600px)" srcset="../../../assets/images/doctor/by-effects/cough.png">
                <img src="../../../assets/images/doctor/by-effects/cough.png" alt="By effect img">
            </picture>
        </template>

        <template v-slot:content>
            <p>Під час лікування у пацієнта з'явилися скарги на <strong>кашель, утруднене дихання, хрипи</strong></p>
            <p><strong>Ro: затемнення нижньої долі правої легені, ознаки плевриту</strong></p>
        </template>
    </by-effect>
</template>

<script>
import ByEffect from './ByEffect';

export default {
    components : {
        'by-effect' : ByEffect
    }
}
</script>

<style lang="scss" scoped>
</style>